import { Button, Col, Form, Row } from "antd";
import moment from "moment";
import { memo, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  onCreateNewFilter,
  onGetBuyerList,
  onGetBuyingOfficeList,
  onGetItemCategoryList,
  onGetItemList,
  onGetOrganizationList,
  onGetSewingLineList,
} from "../../redux/actions";
import ActivityLogFilterFields from "./FilterFields/ActivityLogFilterFields";
import AssignmentFilterFields from "./FilterFields/AssignmentFilterFields";
import BoltSealLogFilterField from "./FilterFields/BoltSealLogFilterField";
import BOMFilterFields from "./FilterFields/BOMFilterFields";
import BookingQtyFilterFields from "./FilterFields/BookingQtyFilterFields";
import BuyerFilterFields from "./FilterFields/BuyerFilterFields";
import BuyerInquiryFilterFields from "./FilterFields/BuyerInquiryFilterFields";
import BuyerStyleChecklistFilterFields from "./FilterFields/BuyerStyleChecklistFilterFields";
import BuyingOfficeFilterFields from "./FilterFields/BuyingOfficeFilterFields";

import AuditReportFilter from "./FilterFields/AuditReportFilter";
import QcValidationReportFilter from "./FilterFields/QcValidationReportFilter";
import AmendmentLienCostFilterFields from "./FilterFields/AmendmentLienCostFilterFields";
import EbCollectionChargeFilterFields from "./FilterFields/EbCollectionChargeFilterFields";
import TransportationCostFilterFields from "./FilterFields/TransportationCostFilterFields";
import B2BLCAcceptanceCommissionFilterFields from "./FilterFields/B2BLCAcceptanceCommissionFilterFields";
import B2BLcAmendmentOpeningCostFilterFields from "./FilterFields/B2BLcAmendmentOpeningCostFilterFields";
import B2BLcOpeningCostFilterFields from "./FilterFields/B2BLcOpeningCostFilterFields";
import B2BLcShippingGuaranteeCostFilterFields from "./FilterFields/B2BLcShippingGuaranteeCostFilterFields";
import BgmeaUdAmendmentFilterFields from "./FilterFields/BgmeaUdAmendmentFilterFields";
import BgmeaUdExportPermissionCostFilterFields from "./FilterFields/BgmeaUdExportPermissionCostFilterFields";
import BuyerInspectionDateFilterFields from "./FilterFields/BuyerInspectionDateFilterFields";
import BuyerPackingReportFilterFields from "./FilterFields/BuyerPackingReportFilterFields";
import BuyerVisitDateFilterFields from "./FilterFields/BuyerVisitDateFilterFields";
import CapacityBookingsReportFilterFields from "./FilterFields/CapacityBookingsReportFilterFields";
import CertificateOfOriginFeeFilterFields from "./FilterFields/CertificateOfOriginFeeFilterFields";
import ChecklistQuestionsFilter from "./FilterFields/ChecklistQuestionsFilter";
import CommercialPackingRequirementFilterFields from "./FilterFields/CommercialPackingRequirementFilterFields";
import ConfigurationFilterFields from "./FilterFields/ConfigurationFilterFields";
import CostEstimateFilterFields from "./FilterFields/CostEstimateFilterFields";
import CuttingFilterFields from "./FilterFields/CuttingFilterFields";
import DailyFinishingLinePlanFilter from "./FilterFields/DailyFinishingLinePlanFilter";
import DailyPackingAssignmentFilterFields from "./FilterFields/DailyPackingAssignmentFilterFields";
import DailyLinePlanFilter from "./FilterFields/DailyLinePlanFilter";
import DigitalAppRoleFilter from "./FilterFields/DigitalAppRoleFilter";
import DigitalDefectCategoryFilter from "./FilterFields/DigitalDefectCategoryFilter";
import DigitalDefectCategoryMappingFilter from "./FilterFields/DigitalDefectCategoryMappingFilter";
import DigitalDefectLineSectionMappingFilter from "./FilterFields/DigitalDefectLineSectionMappingFilter";
import DigitalDefectReasonFilter from "./FilterFields/DigitalDefectReasonFilter";
import DigitalDefectRecommendationFilter from "./FilterFields/DigitalDefectRecommendationFilter";
import DigitalDefectResponsibleFilter from "./FilterFields/DigitalDefectResponsibleFilter";
import DigitalizationGarmentsTrackingFilter from "./FilterFields/DigitalizationGarmentsTrackingFilter";
import DigitalizationOperatorEfficiencyFilter from "./FilterFields/DigitalizationOperatorEfficiency";
import DigitalizationUserLineAssignList from "./FilterFields/DigitalizationUserLineAssignList";
import ERPUsageIssueFilterFields from "./FilterFields/ERPUsageIssueFilterFields";
import ERPUsageModuleFilterFields from "./FilterFields/ERPUsageModuleFilterFields";
import ERPUsageModuleUiFilterFields from "./FilterFields/ERPUsageModuleUiFilterFields";
import ExportDetailsFilterFields from "./FilterFields/ExportDetailsFilterFields";
import ExportDocumentationFeeFilterFields from "./FilterFields/ExportDocumentationFeeFilterFields";
import FabricStoreEntryFilterFields from "./FilterFields/FabricStoreEntryFilterFields";
import FabricReconcilFilterFields from "./FilterFields/FabricReconcilFilterFields";
import FailedItemsFilterFields from "./FilterFields/FailedItemsFilterFields";
import FinishingHourlyIronFilter from "./FilterFields/FinishingHourlyIronFilter";
import FinishingSewingToFoldingFilter from "./FilterFields/FinishingSewingToFoldingFilter";
import FoldingFilterFields from "./FilterFields/FoldingFilterFields";
import HourlyProductionRecFilterField from "./FilterFields/HourlyProductionRecFilterField";
import HourlyProRecDetailsFilter from "./FilterFields/HourlyProRecDetailsFilter";
import HROTExpenseDataFilter from "./FilterFields/HROTExpenseDataFilter";
import ImportAcceptanceDetailFilterFields from "./FilterFields/ImportAcceptanceDetailFilterFields";
import ImportB2blcFilterFields from "./FilterFields/ImportB2blcFilterFields";
import ImportDetailFilterFields from "./FilterFields/ImportDetailFilterFields";
import ImportPiFilterFields from "./FilterFields/ImportPiFilterFields";
import ImportVehicleAssignmentFilterFields from "./FilterFields/ImportVehicleAssignmentFilterFields";
import ImportVehicleInfoFilterFields from "./FilterFields/ImportVehicleInfoFilterFields";
import ImportVehicleStatusFilterFields from "./FilterFields/ImportVehicleStatusFilterFields";
import InitialSAMEntryFilter from "./FilterFields/InitialSAMEntryFilter";
import HourlyProductionDetailFilterFields from "./FilterFields/HourlyProductionDetailFilterFields";
import InventoryDetailFilterFields from "./FilterFields/InventoryDetailFilterFields";
import InventoryMRRFilterFields from "./FilterFields/InventoryMRRFilterFields";
import ItemCategoryFilterFields from "./FilterFields/ItemCategoryFilterFields";
import ItemListFilterFields from "./FilterFields/ItemListFilterFields";
import LearningCurveFilterFields from "./FilterFields/LearningCurveFilterFields";
import LienCostFilterFields from "./FilterFields/LienCostFilterFields";
import LocalPurchaseReconciliationFilterFields from "./FilterFields/LocalPurchaseReconciliationFilterFields";
import MachineConfigFilterCommon from "./FilterFields/MachineConfigFilterCommon";
import MachineInformationFilter from "./FilterFields/MachineInformationFilter";
import MachineIssuesFilter from "./FilterFields/MachineIssuesFilter";
import MechanicUserListFilter from "./FilterFields/MechanicUserListFilter";
import MerchandisingSubContractFactory from "./FilterFields/MerchandisingSubContractFactory";
import NotificationSettingsFilterFields from "./FilterFields/NotificationSettingsFilterFields";
import NotificationSlugsFilterFields from "./FilterFields/NotificationSlugsFilterFields";
import NotingAssessmentFilterFields from "./FilterFields/NotingAssessmentFilterFields";
import OBFilterFields from "./FilterFields/OBFilterFields";
import OperatorAbsenteeismFilterField from "./FilterFields/OperatorAbsenteeismFilterField";
import OrganizationFilterFields from "./FilterFields/OrganizationFilterFields";
import OSRFilterFields from "./FilterFields/OSRFilterFileds";
import OTSignalFilterFields from "./FilterFields/OTSignalFilterFields";
import PackingFilterFields from "./FilterFields/PackingFilterFields";
import PackingFoldingToPackingFilter from "./FilterFields/PackingFoldingToPacking";
import PackingReportFilterFields from "./FilterFields/PackingReportFilterFields";
import PackingOperatorMappingFilterFields from "./FilterFields/PackingOperatorMappingFilterFields";
import PostCostingReportFilter from "./FilterFields/PostCostingReportFilter";
import PPMeetingDateFilterFields from "./FilterFields/PPMeetingDateFilterFields";
import ProductionDefectFilterField from "./FilterFields/ProductionDefectFilterField";
import ProductionDetailsFilterFileds from "./FilterFields/ProductionDetailsFilterFileds";
import PurchaseOrderFilterFields from "./FilterFields/PurchaseOrderFilterFields";
import RemedyMapFilter from "./FilterFields/RemedyMapFilter";
import ReportBoltSealFilterFields from "./FilterFields/ReportBoltSealFilterField";
import SalesContractCommercialFilterFields from "./FilterFields/SalesContractCommercialFilterFields";
import SalesContractFilterFields from "./FilterFields/SalesContractFilterFields";
import SalesContractPOSFilterFields from "./FilterFields/SalesContractPOSFilterFields";
import SecurityBoltFilterFields from "./FilterFields/SecurityBoltFilterFields";
import SewingFilterFields from "./FilterFields/SewingFilterFields";
import SewingLineFilterFields from "./FilterFields/SewingLineFilterFields";
import ShipmentHandoverFilterFields from "./FilterFields/ShipmentHandoverFilterFields";
import StockLotConfigsFields from "./FilterFields/StockLotConfigsFields";
import StoreRequisitionFilterFields from "./FilterFields/StoreRequisitionFilterFields";
import StyleFilterFields from "./FilterFields/StyleFilterFields";
import SubmissionRealizationFilterFields from "./FilterFields/SubmissionRealizationFilterFields";
import SubSalesContractFilterFields from "./FilterFields/SubSalesContractFilterFields";
import SupervisorChecklistFilterField from "./FilterFields/SupervisorChecklistFilterField";
import SwingvsFoldingFilterFields from "./FilterFields/SwingvsFoldingFilterFields";
import OperatorAbsenteeismFilterFields from "./FilterFields/OperatorAbsenteeismFilterFields";
import AbsenteeismInformedReasonFilterFields from "./FilterFields/AbsenteeismInformedReasonFilterFields";
import TNADepartmentFields from "./FilterFields/TNADepartmentFields";
import TNAProcessFields from "./FilterFields/TNAProcessFields";
import TNATaskFields from "./FilterFields/TNATaskFields";
import TNATodoFilter from "./FilterFields/TNATodoFilter";
import NewTodoStyleFilter from "./FilterFields/NewTodoStyleFilter";
import UnitConvertionFilterFields from "./FilterFields/UnitConvertionFilterFields";
import UserRoleFilterFields from "./FilterFields/UserRoleFilterFields";
import UsersFilterFields from "./FilterFields/UsersFilterFields";
import VehicleAndDriverInformationFilterField from "./FilterFields/VehicleAndDriverInformationFilterField";
// import DigitalizationGarmentsTrackingFilter from "./FilterFields/DigitalizationGarmentsTrackingFilter";
// import FinishingHourlyIronFilter from "./FilterFields/FinishingHourlyIronFilter";
// import PackingFoldingToPackingFilter from "./FilterFields/PackingFoldingToPacking";
// import MachineConfigFilterCommon from "./FilterFields/MachineConfigFilterCommon";
import IOUCostFilter from "./FilterFields/IOUCostFilter";
import MarinaCoverNoteFilter from "./FilterFields/MarinaCoverNoteFilter";
import TnaPlanFilterFields from "./FilterFields/TnaPlanFilterFields";

import MismatchReportFilter from "./FilterFields/MismatchReportFilter";
import FoldingRequirementFilterFields from "./FilterFields/FoldingRequirementFilterFields";
import SupplierwiseItemPriceReportFields from "./FilterFields/SupplierwiseItemPriceReportFields";
import PIReportFilterFields from "./FilterFields/PIReportFilterFields";
import SalesContractCostReportFields from "./FilterFields/SalesContractCostReportFields";
import HourlyOperationTrackingFilterFields from "./FilterFields/HourlyOperationTrackingFilterFields";
import HourlyPackingConfirmationFilterFields from "./FilterFields/HourlyPackingConfirmationFilterFields";
import DateRangePresets from "./DateRangePresets";

// ux2(A/presets): filterName -> start/end Form.Item name pairs that get the
// shared six-window preset row. Field names must match each FilterFields
// file's own (often round-1-seeded) `name`s exactly -- see DateRangePresets.js.
const DATE_PRESET_FIELDS = {
  activity_log: [{ startName: "start", endName: "end" }],
  assignment_filter: [{ startName: "assignment_date" }],
  audit_report: [{ startName: "start_date", endName: "end_date" }],
  buyer_inspection_date: [{ startName: "date" }],
  buyer_style_checklist_filter: [{ startName: "filter_date" }],
  buyer_visit_date: [{ startName: "date" }],
  cutting_filter: [{ startName: "cutting_date" }],
  daily_packing_assignment: [{ startName: "plan_date" }],
  "digitalization-garments-tracking": [{ startName: "date" }],
  fabric_reconcil: [{ startName: "start_date", endName: "end_date" }],
  failed_items: [{ startName: "sync_date" }],
  folding_filter: [{ startName: "folding_date" }],
  hourly_operation_tracking: [{ startName: "query_date" }],
  hourly_packing_confirmation: [{ startName: "entry_date" }],
  // hourly_production_detail intentionally excluded: press-preview page (156 s / 19 MB per week,
  // round-3 T1); no one-click ranges -- R3-3
  hourly_production_record: [{ startName: "date" }],
  hourly_production_record_details: [{ startName: "date" }],
  import_acceptance_detail: [{ startName: "from_date", endName: "to_date" }],
  import_b2blc: [{ startName: "from_date", endName: "to_date" }],
  import_detail: [{ startName: "from_date", endName: "to_date" }],
  import_vehicle_info: [{ startName: "from_date", endName: "to_date" }],
  import_vehicle_status: [{ startName: "from_date", endName: "to_date" }],
  inventory_details: [{ startName: "start_date", endName: "end_date" }],
  inventory_mrr: [{ startName: "start_date", endName: "end_date" }],
  "machine-issues": [{ startName: "issue_date" }],
  // Preview on this page is an Excel export; presets must run Search -- R8-9
  "mismatch-report-filter": [{ startName: "entry_date", apply: "submit" }],
  operator_absenteeism_report_filter: [{ startName: "start_date", endName: "end_date" }],
  packing_filter: [{ startName: "packing_date" }],
  pi_report: [{ startName: "start_date", endName: "end_date" }],
  post_cutting_filter: [{ startName: "movement_date" }],
  pp_meeting_date: [{ startName: "date" }],
  // Preview on this page is an Excel export; presets must run Search -- R8-9
  production_defect: [{ startName: "date", apply: "submit" }],
  // production_details: single-date entry only -- R8-1, supersedes R3-5's exclusion
  production_details: [{ startName: "start_date" }],
  qc_validation_report: [{ startName: "start_date", endName: "end_date" }],
  sales_contract_pos: [{ startName: "start", endName: "end" }],
  sewing_and_folding: [{ startName: "start_date", endName: "end_date" }],
  sewing_filter: [{ startName: "sewing_date" }],
  report_bolt_seal: [
    { startName: "arrival_start_date", endName: "arrival_end_date", label: "Arrival" },
    { startName: "dispatch_start_date", endName: "dispatch_end_date", label: "Dispatch" },
  ],
};

const AdvancedSearchForm = memo((props) => {
  // Props
  const {
    initialTableData,
    filterName,
    fetchTableData,
    searchButtonText,
    customButton,
    importDownload,
    filterAPI,
    disabledButton,
    isPreview = false,
    previewFunction = () => { },
    setTableData,
    setSupplierType,
    filterValues,
    setFilterValues,
    preview = "Preview",
  } = props;

  // Antd Constants
  const [form] = Form.useForm();
  const [filterClearTrigger, setFilterClearTrigger] = useState(0);
  const location = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const params = {};
    for (const [key, value] of searchParams.entries()) {
      params[key] = value;
    }
    if (Object.keys(params).length > 0) {
      form.setFieldsValue(params);
    }
  }, [form, location.search]);

  // Redux Constants
  const dispatch = useDispatch();

  // ux3(T3): hoisted out of the Preview button's onClick so DateRangePresets
  // (round-2, R3-4) can drive the same Preview-only fetch path a preset click
  // sets fields on -- previously a preset on an isPreview page only set the
  // date fields and never refreshed the table.
  const runPreview = async () => {
    const value = form.getFieldsValue();
    try {
      await form.validateFields();
      await previewFunction(value);
    } catch (error) {
      // Handle Errors here
    }
  };

  const onFinish = (values, initialTableData, filterName) => {
    dispatch(onCreateNewFilter(values));
    // Save filter values in local storage
    if (filterName && values) {
      localStorage.setItem(`${filterName}_filter_value`, JSON.stringify(values));
    }

    // if (!values && filterName === "import_detail") {
    //   // Do nothing when clear is clicked for import_detail
    //   setTableData([]);
    //   return;
    // }

    if (!values && filterName === "sales_contract_costing_report") {
      // Do nothing when clear is clicked for sales_contract_costing_report
      return;
    }

    switch (filterName) {
      case "iou_cost":
        fetchTableData({
          iou_number: values?.iou_number || null,
          status: values?.status || null,
          taken_by: values?.taken_by || null,
          from_date: values?.from_date ? moment(values?.from_date).format("YYYY-MM-DD") : null,
          to_date: values?.to_date ? moment(values?.to_date).format("YYYY-MM-DD") : null,
        });
        break;
      case "organization":
        dispatch(
          onGetOrganizationList({
            page: 1,
            per_page: 10,
            ...values,
          }),
        );
        break;
      case "buyer":
        dispatch(
          onGetBuyerList({
            page: 1,
            per_page: 10,
            ...values,
          }),
        );
        break;
      case "buying_office":
        dispatch(
          onGetBuyingOfficeList({
            page: 1,
            per_page: 10,
            ...values,
          }),
        );
        break;
      case "item_category":
        dispatch(
          onGetItemCategoryList({
            page: 1,
            per_page: 10,
            ...values,
          }),
        );
        break;
      case "item_list":
        dispatch(
          onGetItemList({
            page: 1,
            per_page: 10,
            ...values,
          }),
        );
        break;
      case "sewing_line":
        dispatch(
          onGetSewingLineList({
            page: 1,
            per_page: 10,
            ...values,
          }),
        );
        break;
      case "style":
        fetchTableData({
          page: 1,
          per_page: 10,
          buying_office_id: values?.buying_office_id,
          buyer_id: values?.buyer_id,
          brand_id: values?.brand_id,
          style_no: values?.style_no,
        });
        break;
      case "sales_contract_commercial":
        fetchTableData({
          page: 1,
          per_page: 10,
          sales_contract_id: values?.sales_contract_id,
          tag_number: values?.tag_number,
          buyer_name: values?.buyer_name,
          sales_contract_value: values?.sales_contract_value,
        });
        break;
      case "export_details":
        fetchTableData({
          page: 1,
          per_page: 10,
          invoice_number: values?.invoice_number,
          invoice_date: values?.invoice_date ? moment(values?.invoice_date).format("YYYY-MM-DD") : null,
          sales_contract_id: values?.sales_contract_id,
        });
        break;
      case "tna_plan":
        fetchTableData({
          page: 1,
          per_page: 10,
          sales_contract_id: values?.sales_contract_id ?? null,
          buyer_id: values?.buyer_id ?? null,
        });
        break;
      case "commercial_packing_requirement":
        fetchTableData({
          page: 1,
          per_page: 10,
          sales_contract_id: values?.sales_contract_id,
        });
        break;
      case "failed_items":
        fetchTableData({
          module_name: values?.module_name,
          sync_date: moment(values?.sync_date).format("YYYY-MM-DD"),
        });
        break;
      case "import_b2blc":
        fetchTableData({
          page: 1,
          per_page: 10,
          b2b_lc_number: values?.b2b_lc_number,
          b2b_lc_date: values?.b2b_lc_date,
          sales_contract_id: values?.sales_contract_id,
          supplier_id: values?.supplier_id,
          from_date: values?.from_date ? moment(values?.from_date).format("YYYY-MM-DD") : null,
          to_date: values?.to_date ? moment(values?.to_date).format("YYYY-MM-DD") : null,
        });
        break;
      case "b2b_lc_shipping_guarantee_cost":
        fetchTableData({
          page: 1,
          per_page: 10,
          ...(values?.b2b_lc_number && { b2b_lc_id: values.b2b_lc_number }),
        });
        break;
      case "import_pi":
        fetchTableData({
          page: 1,
          per_page: 10,
          pi_number: values?.pi_number,
          sales_contract_id: values?.sales_contract_id,
          supplier_id: values?.supplier_id,
          status: values?.status,
        });
        break;
      case "import_detail":
        fetchTableData({
          page: 1,
          per_page: 10,
          position_type: values?.position_type,
          supplier_type: values?.supplier_type,
          invoice_number: values?.invoice_number,
          b2b_lc_number: values?.b2b_lc_number,
          sales_contract_id: values?.sales_contract_id,
          quantity_ctn: values?.quantity_ctn,
          quantity_yds: values?.quantity_yds,
          total_lc_value: values?.total_lc_value,
          from_date: values?.from_date ? moment(values?.from_date).format("YYYY-MM-DD") : null,
          to_date: values?.to_date ? moment(values?.to_date).format("YYYY-MM-DD") : null,
        });
        break;
      case "import_acceptance_detail":
        fetchTableData({
          page: 1,
          per_page: 10,
          terms_of_payment: values?.terms_of_payment,
          import_lc_number: values?.import_lc_number,
          supplier_id: values?.supplier_id,
          type: values?.type,
          from_date: values?.from_date ? moment(values?.from_date).format("YYYY-MM-DD") : null,
          to_date: values?.to_date ? moment(values?.to_date).format("YYYY-MM-DD") : null,
        });
        break;
      case "noting_assessment":
        fetchTableData({
          page: 1,
          per_page: 10,
          invoice_id: values?.invoice_id,
          utilization_declearation_number: values?.utilization_declearation_number,
        });
        break;
      case "security_bolt":
        fetchTableData({
          page: 1,
          per_page: 10,
          security_bolt_seal_number: values?.security_bolt_seal_number,
        });
        break;
      case "submission_realization":
        fetchTableData({
          page: 1,
          per_page: 10,
          invoice_number: values?.invoice_number,
          sales_contract_id: values?.sales_contract_id,
          fdbc_number: values?.fdbc_number,
        });
        break;
      case "sales_contract":
        fetchTableData({
          page: 1,
          per_page: 10,
          sales_contract_unique_id: values?.sales_contract_unique_id,
          reference_no: values?.reference_no,
          buyer_id: values?.buyer_id,
          contract_date: values?.contract_date,
        });
        break;
      case "purchase_order":
        fetchTableData({
          page: 1,
          per_page: 10,
          buying_office_id: values?.buying_office_id,
          sales_contract_id: values?.sales_contract_id,
          buyer_id: values?.buyer_id,
          contract_status: values?.contract_status,
          po_map_id: values?.po_map_id,
        });
        break;
      case "folding_requirement":
        fetchTableData({
          page: 1,
          per_page: 10,
          style_id: values?.style_id,
          sub_style_id: values?.sub_style_id,
          po_map_id: values?.po_map_id,
        });
        break;
      case "hourly_operation_tracking":
        // Only call API if both query_date and line_id are provided
        // If values is null (clear button), reset the state by calling with empty filter
        if (!values) {
          fetchTableData({});
        } else if (values?.query_date && values?.line_id) {
          fetchTableData({
            page: 1,
            per_page: 10,
            query_date: moment(values?.query_date).format("YYYY-MM-DD"),
            line_id: values?.line_id,
          });
        }
        break;
      case "bom":
        fetchTableData({
          page: 1,
          per_page: 10,
          buying_office_id: values?.buying_office_id,
          sales_contract_id: values?.sales_contract_id,
          buyer_id: values?.buyer_id,
          style_id: values?.style_id,
        });
        break;
      case "stock-lot-configs":
        fetchTableData({
          sales_contract_id: values?.sales_contract_id,
          sub_contract_factory_id: values?.sub_contract_factory_id,
          buyer_id: values?.buyer_id,
          style_id: values?.style_id,
        });
        break;
      case "configuration":
        fetchTableData({
          name: values?.name,
        });
        break;
      case "packing_operator_mapping":
        fetchTableData({
          packing_line_id: values?.packing_line_id || "",
          operator_id: values?.operator_id || "",
          status: values?.status || "",
        });
        break;
      case "unit_convertion":
        fetchTableData({
          convert_from: values?.convert_from,
          convert_to: values?.convert_to,
        });
        break;
      case "activity_log":
        fetchTableData({
          start: values?.start ? moment(values?.start).format("DD-MM-YYYY") : null,
          end: values?.end ? moment(values?.end).format("DD-MM-YYYY") : null,
          action: values?.action,
          movement_type: values?.movement_type,
          acted_by: values?.acted_by,
          ui_model_name: values?.ui_model_name,
        });
        break;
      case "packing_list":
        fetchTableData({
          buying_office_id: values?.buying_office_id,
          buyer_id: values?.buyer_id,
          sales_contract_id: values?.sales_contract_id,
          po_map_id: values?.po_map_id,
        });
        break;
      case "inventory_mrr":
        fetchTableData({
          start_date: values?.start_date,
          end_date: values?.end_date,
          supplier_id: values?.supplier_id,
        });
        break;
      case "pi_report":
        fetchTableData({
          start_date: values?.start_date,
          end_date: values?.end_date,
        });
        break;
      case "inventory_details":
        if (values !== null) {
          fetchTableData({
            start_date: values?.start_date,
            end_date: values?.end_date,
            style_id: values?.style_id,
            item_category_ids: values?.item_category_ids,
            challan_ids: values?.challan_ids,
          });
        } else {
          setTableData([]);
        }
        break;
      case "packing_report":
        fetchTableData({
          po_map_id: values?.po_map_id,
        });
        break;
      case "buyer_packing_report":
        fetchTableData({
          po_map_id: values?.po_map_id,
          style_id: values?.style_id,
        });
        break;
      case "hourly_production_detail":
        fetchTableData({
          start_date: values?.start_date ? moment(values?.start_date).format("YYYY-MM-DD") : null,
          end_date: values?.end_date ? moment(values?.end_date).format("YYYY-MM-DD") : null,
          style_id: values?.style_id || null,
        });
        break;
      case "fabric_reconcil":
        fetchTableData({
          start_date: values?.start_date,
          end_date: values?.end_date,
          sales_contract_id: values?.sales_contract_id,
          style_id: values?.style_id,
          buying_office_id: values?.buying_office_id,
          buyer_id: values?.buyer_id,
          first_party: values?.first_party,
        });
        break;
      case "cost_estimate":
        fetchTableData({
          sales_contract_id: values?.sales_contract_id,
        });
        break;
      case "users_list":
        fetchTableData({
          name: values?.name,
          email: values?.email,
          id_card_no: values?.id_card_no,
          role_id: values?.role_id,
        });
        break;
      case "production_details":
        fetchTableData({
          start_date: values?.start_date,
          end_date: values?.end_date,
          sales_contract_id: values?.sales_contract_id,
          style_id: values?.style_id,
          buying_office_id: values?.buying_office_id,
          buyer_id: values?.buyer_id,
        });
        break;
      case "supplier_wise_item_price_report":
        fetchTableData({
          good_description: values?.good_description,
          item_category_ids: values?.item_category_ids,
          item_ids: values?.item_ids,
          supplier_id: values?.supplier_id,
        });
        break;
      case "sales_contract_costing_report":
        fetchTableData({
          sales_contract_id: values?.sales_contract_id,
        });
        break;
      case "post-costing-report":
        fetchTableData({
          sales_contract_id: values?.sales_contract_id,
        });
        break;
      case "user_role_filter":
        fetchTableData({
          name: values?.name,
        });
        break;
      case "notification_slugs":
        fetchTableData({
          page: 1,
          per_page: 10,
          name: values?.name,
          code: values?.code,
        });
        break;
      case "notification_settings":
        fetchTableData({
          page: 1,
          per_page: 10,
          name: values?.name,
        });
        break;
      case "import_vehicle_status":
        fetchTableData({
          per_page: 10,
          invoice_number: values?.invoice_number,
          buyer_name: values?.buyer_name,
          vehicle_number: values?.vehicle_number,
          b2b_lc_number: values?.import_lc_number,
          from_date: values?.from_date ? moment(values?.from_date).format("YYYY-MM-DD") : null,
          to_date: values?.to_date ? moment(values?.to_date).format("YYYY-MM-DD") : null,
        });
        break;
      case "import_vehicle_info":
        fetchTableData({
          per_page: 10,
          type_of_shipment: values?.type_of_shipment,
          invoice_number: values?.invoice_number,
          b2b_lc_number: values?.import_lc_number,
          from_date: values?.from_date ? moment(values?.from_date).format("YYYY-MM-DD") : null,
          to_date: values?.to_date ? moment(values?.to_date).format("YYYY-MM-DD") : null,
        });
        break;
      case "import_vehicle_assignment":
        fetchTableData({
          page: 1,
          per_page: 10,
          type_of_shipment: values?.type_of_shipment,
          invoice_number: values?.invoice_number,
          buyer_name: values?.buyer_name,
          b2b_lc_id: values?.b2b_lc_id,
          sales_contract_id: values?.sales_contract_id,
          import_details_id: values?.import_details_id,
        });
        break;
      case "learning_curve":
        fetchTableData({
          page: 1,
          per_page: 10,
          range_start: values?.range_start,
          range_end: values?.range_end,
        });
        break;
      case "buyer_inquiry":
        fetchTableData({
          page: 1,
          per_page: 10,
          inquiry_no: values?.inquiry_no,
          buying_office_id: values?.buying_office_id,
          buyer_id: values?.buyer_id,
          brand_id: values?.brand_id,
          style_id: values?.style_id,
          cm_status: values?.cm_status,
          received_by: values?.received_by,
          ob_status: values?.ob_status,
        });
        break;
      case "tna_process":
        fetchTableData({
          page: 1,
          per_page: 10,
          title: values?.title,
        });
        break;
      case "tna_department":
        fetchTableData({
          page: 1,
          per_page: 10,
          title: values?.title,
        });
        break;
      case "remedy_map_filter":
        fetchTableData({
          page: 1,
          per_page: 10,
          tna_department_id: values?.tna_department_id,
          problem_type_id: values?.problem_type_id,
          problem_id: values?.problem_id,
          reason_id: values?.reason_id,
          remedy_id: values?.remedy_id,
        });
        break;
      case "remedy_logs_filter":
        fetchTableData({
          page: 1,
          per_page: 10,
          tna_department_id: values?.tna_department_id,
          problem_type_id: values?.problem_type_id,
          problem_id: values?.problem_id,
          reason_id: values?.reason_id,
          remedy_id: values?.remedy_id,
        });
        break;

      case "tna_task":
        fetchTableData({
          page: 1,
          per_page: 10,
          title: values?.title,
          process: values?.process,
          tna_process_id: values?.process,
          relation_with: values?.relation_with,
        });
        break;
      case "tna_new_task":
        fetchTableData({
          page: 1,
          per_page: 10,
          title: values?.title,
          process: values?.process,
          tna_process_id: values?.process,
          relation_with: values?.relation_with,
        });
        break;
      case "tna_todo":
        fetchTableData({
          page: 1,
          per_page: 10,
          action_statuses: values?.todoTask,
          date_range: values?.date_range,
          buyer_id: values?.buyer_id,
          responsible_person_id: values?.responsible_person_id,
        });
        break;
      case "new_todo_style_filter":
        fetchTableData({
          style_id: values?.style_id || null,
        });
        break;
      case "cutting_filter":
        fetchTableData({
          cutting_date: values?.cutting_date ? moment(values?.cutting_date).format("YYYY-MM-DD") : null,
          buyer_id: values?.buyer_id,
          style_id: values?.style_id,
        });
        break;
      case "post_cutting_filter":
        fetchTableData({
          movement_date: values?.movement_date ? moment(values?.movement_date).format("YYYY-MM-DD") : null,
          buyer_id: values?.buyer_id,
          style_id: values?.style_id,
        });
        break;
      case "assignment_filter":
        fetchTableData({
          assignment_date: values?.assignment_date ? moment(values?.assignment_date).format("YYYY-MM-DD") : null,
          buyer_id: values?.buyer_id,
          style_id: values?.style_id,
          sub_style_id: values?.sub_style_id || null,
        });
        break;
      case "sewing_filter":
        fetchTableData({
          sewing_date: values?.sewing_date ? moment(values?.sewing_date).format("YYYY-MM-DD") : null,
          buyer_id: values?.buyer_id,
          style_id: values?.style_id,
        });
        break;
      case "folding_filter":
        fetchTableData({
          folding_date: values?.folding_date ? moment(values?.folding_date).format("YYYY-MM-DD") : null,
          buyer_id: values?.buyer_id,
          style_id: values?.style_id,
        });
        break;
      case "store_requisition":
        fetchTableData({
          movement_type: values?.movement_type,
          buyer_id: values?.buyer_id,
          sub_contract_factory_id: values?.sub_contract_factory_id,
          entry_date: values?.entry_date
            ? moment(values?.entry_date).format("YYYY-MM-DD")
            : null,
          requisition_no: values?.requisition_no,
          status: values?.status,
        });
        break;
      case "packing_filter":
        fetchTableData({
          packing_date: values?.packing_date ? moment(values?.packing_date).format("YYYY-MM-DD") : null,
          buyer_id: values?.buyer_id,
          style_id: values?.style_id,
          po_map_id: values?.po_map_id,
        });
        break;
      case "report_bolt_seal":
        fetchTableData({
          arrival_start_date: values?.arrival_start_date,
          arrival_end_date: values?.arrival_end_date,
          dispatch_start_date: values?.dispatch_start_date,
          dispatch_end_date: values?.dispatch_end_date,
        });
        break;
      case "supervisor_checklist":
        fetchTableData({
          line_id: values?.line_id,
          user_id: values?.user_id,
        });
        break;
      case "production_defect":
        fetchTableData({
          per_page: values?.per_page || 10,
          date: values?.date ? moment(values?.date).format("YYYY-MM-DD") : null,
          line_id: values?.line_id,
          operation: values?.operation,
          category_id: values?.category_id,
          user_id: values?.user_id,
        });
        break;
      case "digitalization-garments-tracking":
        fetchTableData({
          per_page: values?.per_page || 10,
          date: values?.date ? moment(values?.date).format("YYYY-MM-DD") : null,
          line_id: values?.line_id || null,
          style_id: values?.style_id || null,
          buyer_id: values?.buyer_id || null,
          sub_style_id: values?.sub_style_id || null,
        });
        break;
      case "finishing-sewing-to-folding":
        fetchTableData({
          per_page: values?.per_page || 10,
          line_id: values?.line_id || null,
          style_id: values?.style_id || null,
          sub_style_id: values?.sub_style_id || null,
          po_map_id: values?.po_map_id || null,
        });
        break;

      case "finishing-hourly-iron":
      case "finishing-hourly-fold":
      case "finishing-hourly-poly":
        fetchTableData({
          per_page: values?.per_page || 10,
          finishing_line_id: values?.finishing_line_id || null,
          style_id: values?.style_id || null,
          sub_style_id: values?.sub_style_id || null,
          original_po: values?.original_po || null,
          po_map_id: values?.po_map_id || null,
          entry_date: values?.entry_date
            ? moment(values?.entry_date).format("YYYY-MM-DD")
            : null,
        });
        break;

      case "mismatch-report-filter":
        fetchTableData({
          // per_page: values?.per_page || 10,
          line_id: values?.line_id || null,
          style_id: values?.style_id || null,
          sub_style_id: values?.sub_style_id || null,
          entry_date: values?.entry_date || null,
        });
        break;

      case "folding-to-packing":
        fetchTableData({
          per_page: values?.per_page || 10,
          style_id: values?.style_id || null,
          sub_style_id: values?.sub_style_id || null,
          po_map_id: values?.po_map_id || null,
        });
        break;

      case "machine-information":
        fetchTableData({
          per_page: values?.per_page || 10,
          machine_identifier: values?.machine_identifier || null,
          machine_name: values?.machine_name || null,
          machine_action_type_id: values?.machine_action_type_id || null,
          machine_brand_id: values?.machine_brand_id || null,
          machine_model_id: values?.machine_model_id || null,
          machine_location_id: values?.machine_location_id || null,
          machine_line_id: values?.machine_line_id || null,
          machine_origin_country_id: values?.machine_origin_country_id || null,
          sewing_line_id: values?.sewing_line_id || null,
        });
        break;

      case "mechanic_users_list":
        fetchTableData({
          per_page: values?.per_page || 10,
          name: values?.name || null,
          email: values?.email || null,
          id_card_no: values?.id_card_no || null,
        });
        break;

      case "machine-issues":
        fetchTableData({
          per_page: values?.per_page || 10,
          issue_date: values?.issue_date || null,
          machine_information_id: values?.machine_information_id || null,
          sewing_line_id: values?.sewing_line_id || null,
          machine_line_id: values?.machine_line_id || null,
          machine_fault_type_id: values?.machine_fault_type_id || null,
          status: values?.status || null,
          is_assigned: values?.is_assigned || null,
        });
        break;

      case "machine-configurations":
        fetchTableData({
          per_page: values?.per_page || 10,
          name: values?.name || null,
        });
        break;

      case "operator_absenteeism":
        fetchTableData({
          line_id: values?.line_id,
          user_id: values?.user_id,
        });
        break;
      case "digitalization_daily_line_plan":
        fetchTableData({
          style_id: values?.style || null,
          buyer_id: values?.buyer || null,
          line_id: values?.line || null,
          sub_style_id: values?.sub_style_id || null,
        });
        break;
      case "digitalization_daily_finishing_line_plan":
        fetchTableData({
          style_id: values?.style || null,
          buyer_id: values?.buyer || null,
          line_id: values?.line || null,
          sub_style_id: values?.sub_style_id || null,
        });
        break;
      case "buyer_style_checklist_filter":
        fetchTableData({
          page: 1,
          per_page: 10,
          type: "buyer_wise",
          filter_date: values?.filter_date ? moment(values?.filter_date).format("YY-MM-DD") : null,
        });
        break;
      case "checklist-questions-filter":
        fetchTableData({
          ...values,
          status: values?.status,
          role_id: values?.role_id,
          name: values?.name,
        });
        break;
      case "hourly_production_record":
        fetchTableData({
          filter_date: values?.date ? moment(values?.date).format("YYYY-MM-DD") : null,
        });
        break;
      case "hourly_production_record_details":
        fetchTableData({
          filter_date: values?.date ? moment(values?.date).format("YYYY-MM-DD") : null,
          style_id: values?.style,
          buyer_id: values?.buyer,
          line_id: values?.line,
        });
        break;
      case "sub_sales_contract":
        fetchTableData({
          reference_no: values?.reference_no,
          factory_id: values?.factory_id,
        });
        break;
      case "ot_signal":
        fetchTableData({
          signal_id: values?.signal_id,
          signal_section_id: values?.signal_section_id,
        });
        break;
      case "osr":
        fetchTableData({
          pcd_start: values?.pcd_start ? values?.pcd_start : "",
          pcd_end: values?.pcd_end ? values?.pcd_end : "",
          shipment_start: values?.shipment_start ? values?.shipment_start : "",
          shipment_end: values?.shipment_end ? values?.shipment_end : "",
          buying_office_id: values?.buying_office_id ? values?.buying_office_id : "",
          buyer_id: values?.buyer_id ? values?.buyer_id : "",
          sc_type: values?.sc_type ? values?.sc_type : "",
        });
        break;
      case "buyer_inspection_date":
        fetchTableData({
          date: values?.date ? moment(values?.date).format("YYYY-MM-DD") : null,
          style_id: values?.style_id,
        });
        break;
      case "capacity_bookings_report":
        fetchTableData({
          filterMonth: values?.filterMonth ? moment(values?.filterMonth).format("YYYY-MM") : null,
          // style_id: values?.style_id,
        });
        break;
      case "pp_meeting_date":
        fetchTableData({
          date: values?.date ? moment(values?.date).format("YYYY-MM-DD") : null,
          style_id: values?.style_id,
        });
        break;
      case "buyer_visit_date":
        fetchTableData({
          date: values?.date ? moment(values?.date).format("YYYY-MM-DD") : null,
          buyer_name: values?.buyer_name,
        });
        break;
      case "booking_qty":
        fetchTableData({
          page: 1,
          per_page: 10,
          ...(values?.buyer_id && { buyer_id: values.buyer_id }),
        });
        break;
      case "sewing_and_folding":
        fetchTableData({
          start_date: values?.start_date,
          end_date: values?.end_date,
        });
        break;
      case "operator_absenteeism_report_filter":
        fetchTableData({
          start_date: values?.start_date ? moment(values.start_date).format("YYYY-MM-DD") : null,
          end_date: values?.end_date ? moment(values.end_date).format("YYYY-MM-DD") : null,
        });
        break;
      case "absenteeism_informed_reason_report_filter":
        fetchTableData({
          start_date: values?.start_date
            ? moment(values.start_date).format("YYYY-MM-DD")
            : moment().format("YYYY-MM-DD"),
          end_date: values?.end_date
            ? moment(values.end_date).format("YYYY-MM-DD")
            : moment().format("YYYY-MM-DD"),
        });
        break;
      case "sales_contract_pos":
        fetchTableData({
          start: values?.start,
          end: values?.end,
          sales_contract_id: values?.sales_contract_id,
          original_po: values?.original_po,
        });
        break;
      case "erp_usage_module":
        fetchTableData({
          module_name: values?.module_name,
          status: values?.status,
        });
        break;
      case "erp_usage_module_ui":
        fetchTableData({
          name: values?.name,
          module_id: values?.module_id,
          user_id: values?.user_id,
          tna_department_id: values?.tna_department_id,
          status: values?.status,
        });
        break;
      case "erp_usage_issue":
        fetchTableData({
          title: values?.title,
          ui_id: values?.ui_id,
          user_id: values?.user_id,
          assigned_to_user_id: values?.assigned_to_user_id,
          status: values?.status,
        });
        break;
      case "ob_filter":
        fetchTableData({
          inquiry_id: values?.inquiry_id,
          style_id: values?.style_id,
          sub_style_id: values?.sub_style_id,
        });
        break;
      case "he_ot_expense_data":
        fetchTableData({
          name: values?.name,
          date: values?.date,
          card_no: values?.card_no,
          line_id: values?.line_id,
        });
        break;
      case "digitalization-operator-efficiency":
        fetchTableData({
          checked_date: values?.checked_date ? moment(values?.checked_date).format("YYYY-MM-DD") : null,
          line_id: values?.line_id,
        });
        break;
      case "audit_report":
        if (!values) {
          fetchTableData({ page: 1, per_page: 10 });
          break;
        }
        fetchTableData({
          page: 1,
          per_page: values?.per_page || 10,
          line_id: values?.line_id || null,
          start_date: values?.start_date ? moment(values?.start_date).format("YYYY-MM-DD") : null,
          end_date: values?.end_date ? moment(values?.end_date).format("YYYY-MM-DD") : null,
        });
        break;
      case "qc_validation_report":
        if (!values) {
          fetchTableData({ page: 1, per_page: 10 });
          break;
        }
        fetchTableData({
          page: 1,
          per_page: values?.per_page || 10,
          line_id: values?.line_id || null,
          start_date: values?.start_date ? moment(values?.start_date).format("YYYY-MM-DD") : null,
          end_date: values?.end_date ? moment(values?.end_date).format("YYYY-MM-DD") : null,
        });
        break;
      case "initial_sam_entry":
        fetchTableData({ ...values });
        break;
      case "lien_cost":
        fetchTableData({
          page: 1,
          per_page: 10,
          sales_contract_id: values?.sales_contract_id,
        });
        break;
      case "transportation_cost":
        fetchTableData({
          page: 1,
          per_page: 10,
          invoice_number: values?.invoice_number,
          challan_number: values?.challan_number,
          lc_number: values?.lc_number,
          gate_pass_number: values?.gate_pass_number,
        });
        break;
      case "eb_collection_charge":
        fetchTableData({
          page: 1,
          per_page: 10,
          bank_reference_number: values?.bank_reference_number,
        });
        break;
      case "export_doc_fee":
        fetchTableData({
          page: 1,
          per_page: 10,
          sales_contract_id: values?.sales_contract_id,
        });
        break;
      case "amendment_lien_cost":
        fetchTableData({
          page: 1,
          per_page: 10,
          sales_contract_id: values?.sales_contract_id,
        });
        break;
      case "BGMEA_UD_Amendment":
        fetchTableData({
          page: 1,
          per_page: 10,
          ud_number: values?.ud_number,
        });
        break;
      case "bgmea_ud_export_permission_cost":
        fetchTableData({
          page: 1,
          per_page: 10,
          sales_contract_id: values?.sales_contract_id,
        });
        break;
      case "certificate_of_origin_fee":
        fetchTableData({
          invoice_number: values?.invoice_number,
          sales_contract_number: values?.sales_contract_number,
        });
        break;
      case "marina_cover_note_bill":
        fetchTableData({
          from_date: values?.from_date ? moment(values?.from_date).format("YYYY-MM-DD") : null,
          to_date: values?.to_date ? moment(values?.to_date).format("YYYY-MM-DD") : null,
        });
        break;
      case "hourly_packing_confirmation":
        fetchTableData({
          entry_date: values?.entry_date ? moment(values?.entry_date).format("YYYY-MM-DD") : null,
          packing_line_id: values?.packing_line_id || "",
          packing_table_id: values?.packing_table_id || "",
          sales_contract_id: values?.sales_contract_id || "",
          operator_id: values?.operator_id || "",
          po_map_id: values?.po_map_id || "",
          hour: values?.hour || "",
        });
        break;
      case "daily_packing_assignment":
        fetchTableData({
          plan_date: values?.plan_date ? moment(values?.plan_date).format("DD-MM-YYYY") : null,
          packing_line_id: values?.packing_line_id || "",
          sales_contract_id: values?.sales_contract_id || "",
          buyer_id: values?.buyer_id || "",
          buying_office_id: values?.buying_office_id || "",
          sub_contract_factory_id: values?.sub_contract_factory_id || "",
          po_map_id: values?.po_map_id || "",
        });
        break;
      default:
        break;
    }
  };

  const RenderFilterFields = ({ initialTableData, filterName, filterClearTrigger }) => {
    switch (filterName) {
      case "iou_cost":
        return <IOUCostFilter />;
      case "organization":
        return <OrganizationFilterFields initialTableData={initialTableData} />;
      case "buyer":
        return <BuyerFilterFields initialTableData={initialTableData} />;
      case "buying_office":
        return <BuyingOfficeFilterFields initialTableData={initialTableData} />;
      case "item_category":
        return <ItemCategoryFilterFields initialTableData={initialTableData} />;
      case "item_list":
        return <ItemListFilterFields initialTableData={initialTableData} />;
      case "sewing_line":
        return <SewingLineFilterFields initialTableData={initialTableData} />;
      case "style":
        return <StyleFilterFields initialTableData={initialTableData} />;
      case "sales_contract":
        return <SalesContractFilterFields initialTableData={initialTableData} />;
      case "sub_sales_contract":
        return <SubSalesContractFilterFields initialTableData={initialTableData} />;
      case "sales_contract_commercial":
        return <SalesContractCommercialFilterFields initialTableData={initialTableData} />;
      case "import_pi":
        return <ImportPiFilterFields initialTableData={initialTableData} />;
      case "export_details":
        return <ExportDetailsFilterFields initialTableData={initialTableData} />;
      case "tna_plan":
        return <TnaPlanFilterFields initialTableData={initialTableData} />;
      case "commercial_packing_requirement":
        return <CommercialPackingRequirementFilterFields initialTableData={initialTableData} />;
      case "failed_items":
        return <FailedItemsFilterFields initialTableData={initialTableData} />;
      case "noting_assessment":
        return <NotingAssessmentFilterFields initialTableData={initialTableData} />;
      case "security_bolt":
        return <SecurityBoltFilterFields initialTableData={initialTableData} />;
      case "shipment_handover":
        return <ShipmentHandoverFilterFields initialTableData={initialTableData} />;
      case "import_b2blc":
        return <ImportB2blcFilterFields initialTableData={initialTableData} />;
      case "b2b_lc_shipping_guarantee_cost":
        return <B2BLcShippingGuaranteeCostFilterFields />;
      case "submission_realization":
        return <SubmissionRealizationFilterFields initialTableData={initialTableData} />;
      case "purchase_order":
        return <PurchaseOrderFilterFields initialTableData={initialTableData} />;
      case "folding_requirement":
        return <FoldingRequirementFilterFields initialTableData={initialTableData} />;
      case "hourly_operation_tracking":
        return <HourlyOperationTrackingFilterFields initialTableData={initialTableData} />;
      case "bom":
        return <BOMFilterFields initialTableData={initialTableData} />;
      case "configuration":
        return <ConfigurationFilterFields initialTableData={initialTableData} />;
      case "packing_operator_mapping":
        return <PackingOperatorMappingFilterFields initialTableData={initialTableData} />;
      case "unit_convertion":
        return <UnitConvertionFilterFields initialTableData={initialTableData} />;
      case "activity_log":
        return <ActivityLogFilterFields initialTableData={initialTableData} />;
      case "packing_list":
        return <PackingFilterFields initialTableData={initialTableData} />;
      case "inventory_mrr":
        return <InventoryMRRFilterFields initialTableData={initialTableData} />;
      case "inventory_details":
        return <InventoryDetailFilterFields initialTableData={initialTableData} />;
      case "hourly_production_detail":
        return <HourlyProductionDetailFilterFields initialTableData={initialTableData} />;
      case "packing_report":
        return <PackingReportFilterFields initialTableData={initialTableData} />;
      case "buyer_packing_report":
        return <BuyerPackingReportFilterFields initialTableData={initialTableData} />;
      case "pi_report":
        return <PIReportFilterFields initialTableData={initialTableData} />;
      case "fabric_reconcil":
        return <FabricReconcilFilterFields initialTableData={initialTableData} />;
      case "fabric_store_entry":
        return <FabricStoreEntryFilterFields />;
      case "trims_store_entry":
        return <FabricStoreEntryFilterFields />;
      case "osr":
        return <OSRFilterFields initialTableData={initialTableData} />;
      case "import_detail":
        return <ImportDetailFilterFields initialTableData={initialTableData} setSupplierType={setSupplierType} />;
      case "import_acceptance_detail":
        return <ImportAcceptanceDetailFilterFields initialTableData={initialTableData} />;
      case "cost_estimate":
        return <CostEstimateFilterFields initialTableData={initialTableData} />;
      case "users_list":
        return <UsersFilterFields initialTableData={initialTableData} />;
      case "production_details":
        return <ProductionDetailsFilterFileds initialTableData={initialTableData} />;
      case "supplier_wise_item_price_report":
        return <SupplierwiseItemPriceReportFields initialTableData={initialTableData} />;
      case "sales_contract_costing_report":
        return <SalesContractCostReportFields initialTableData={initialTableData} />;
      case "post-costing-report":
        return <PostCostingReportFilter initialTableData={initialTableData} />;
      case "user_role_filter":
        return <UserRoleFilterFields initialTableData={initialTableData} />;
      case "notification_slugs":
        return <NotificationSlugsFilterFields initialTableData={initialTableData} />;
      case "notification_settings":
        return <NotificationSettingsFilterFields initialTableData={initialTableData} />;
      case "local_purchase_reconciliation":
        return <LocalPurchaseReconciliationFilterFields initialTableData={initialTableData} />;
      case "import_vehicle_status":
        return <ImportVehicleStatusFilterFields initialTableData={initialTableData} />;
      case "import_vehicle_info":
        return <ImportVehicleInfoFilterFields initialTableData={initialTableData} />;
      case "import_vehicle_assignment":
        return <ImportVehicleAssignmentFilterFields initialTableData={initialTableData} />;

      case "learning_curve":
        return <LearningCurveFilterFields initialTableData={initialTableData} />;
      case "sewing":
        return <LearningCurveFilterFields initialTableData={initialTableData} />;
      case "buyer_inquiry":
        return <BuyerInquiryFilterFields initialTableData={initialTableData} />;
      case "tna_process":
        return <TNAProcessFields initialTableData={initialTableData} />;
      case "tna_department":
        return <TNADepartmentFields initialTableData={initialTableData} />;
      case "tna_task":
        return <TNATaskFields initialTableData={initialTableData} />;
      case "tna_new_task":
        return <TNATaskFields initialTableData={initialTableData} />;
      case "tna_todo":
        return <TNATodoFilter initialTableData={initialTableData} />;
      case "new_todo_style_filter":
        return <NewTodoStyleFilter initialTableData={initialTableData} />;
      case "sewing_filter":
        return <SewingFilterFields initialTableData={initialTableData} />;
      case "cutting_filter":
        return (
          <CuttingFilterFields
            initialTableData={initialTableData}
            type={"cutting_filter"}
            filterValues={filterValues}
            setFilterValues={setFilterValues}
          />
        );
      case "post_cutting_filter":
        return (
          <CuttingFilterFields
            initialTableData={initialTableData}
            type={"post_cutting_filter"}
            filterValues={filterValues}
            setFilterValues={setFilterValues}
          />
        );
      case "assignment_filter":
        return <AssignmentFilterFields initialTableData={initialTableData} form={form} />;
      case "folding_filter":
        return <FoldingFilterFields initialTableData={initialTableData} />;
      case "packing_filter":
        return <PackingFilterFields initialTableData={initialTableData} />;
      case "bolt_seal_log":
        return <BoltSealLogFilterField initialTableData={initialTableData} />;
      case "vehicle_and_driver_information":
        return <VehicleAndDriverInformationFilterField initialTableData={initialTableData} />;
      case "report_bolt_seal":
        return <ReportBoltSealFilterFields initialTableData={initialTableData} />;
      case "supervisor_checklist":
        return <SupervisorChecklistFilterField initialTableData={initialTableData} />;
      case "production_defect":
        return <ProductionDefectFilterField initialTableData={initialTableData} />;
      case "hourly_production_record":
        return <HourlyProductionRecFilterField initialTableData={initialTableData} />;
      case "hourly_production_record_details":
        return <HourlyProRecDetailsFilter initialTableData={initialTableData} />;
      case "operator_absenteeism":
        return <OperatorAbsenteeismFilterField initialTableData={initialTableData} />;
      case "digitalization_app_role_list":
        return <DigitalAppRoleFilter initialTableData={initialTableData} />;
      case "digitalization_defect_category":
        return <DigitalDefectCategoryFilter initialTableData={initialTableData} />;
      case "digitalization_defect_reason":
        return <DigitalDefectReasonFilter initialTableData={initialTableData} />;
      case "digitalization_defect_responsible":
        return <DigitalDefectResponsibleFilter initialTableData={initialTableData} />;
      case "digitalization_defect_recommendation":
        return <DigitalDefectRecommendationFilter initialTableData={initialTableData} />;
      case "digitalization_daily_line_plan":
        return (
          <DailyLinePlanFilter
            initialTableData={initialTableData}
            form={form}
            filterClearTrigger={filterClearTrigger}
          />
        );
      case "digitalization_daily_finishing_line_plan":
        return (
          <DailyFinishingLinePlanFilter
            initialTableData={initialTableData}
            form={form}
            filterClearTrigger={filterClearTrigger}
          />
        );
      case "digitalization_defect_category_mapping":
        return <DigitalDefectCategoryMappingFilter initialTableData={initialTableData} />;
      case "digitalization_defect_line_section_mapping":
        return <DigitalDefectLineSectionMappingFilter initialTableData={initialTableData} />;
      case "buyer_style_checklist_filter":
        return <BuyerStyleChecklistFilterFields initialTableData={initialTableData} />;
      case "checklist-questions-filter":
        return <ChecklistQuestionsFilter initialTableData={initialTableData} />;
      case "digitalization_user_line_assign_list":
        return <DigitalizationUserLineAssignList initialTableData={initialTableData} />;
      case "merchandising-sub-contract-factory":
        return <MerchandisingSubContractFactory initialTableData={initialTableData} />;
      case "ot_signal":
        return <OTSignalFilterFields initialTableData={initialTableData} />;
      case "digitalization-garments-tracking":
        return (
          <DigitalizationGarmentsTrackingFilter
            initialTableData={initialTableData}
            filterClearTrigger={filterClearTrigger}
          />
        );
      case "finishing-sewing-to-folding":
        return <FinishingSewingToFoldingFilter />;
      case "folding-to-packing":
        return <PackingFoldingToPackingFilter />;

      case "machine-issues":
        return <MachineIssuesFilter />;

      case "machine-information":
        return <MachineInformationFilter />;

      case "mechanic_users_list":
        return <MechanicUserListFilter />;

      case "machine-configurations":
        return <MachineConfigFilterCommon form={form} />;
      case "finishing-hourly-iron":
      case "finishing-hourly-fold":
      case "finishing-hourly-poly":
        return (
          <FinishingHourlyIronFilter
            initialTableData={initialTableData}
            filterClearTrigger={filterClearTrigger}
          />
        );
      case "mismatch-report-filter":
        return (
          <MismatchReportFilter
            initialTableData={initialTableData}
            filterClearTrigger={filterClearTrigger}
          />
        );
      case "buyer_inspection_date":
        return <BuyerInspectionDateFilterFields initialTableData={initialTableData} />;
      case "capacity_bookings_report":
        return <CapacityBookingsReportFilterFields initialTableData={initialTableData} />;
      case "pp_meeting_date":
        return <PPMeetingDateFilterFields initialTableData={initialTableData} />;
      case "buyer_visit_date":
        return <BuyerVisitDateFilterFields initialTableData={initialTableData} />;
      case "booking_qty":
        return <BookingQtyFilterFields />;
      case "sewing_and_folding":
        return <SwingvsFoldingFilterFields initialTableData={initialTableData} />;
      case "operator_absenteeism_report_filter":
        return <OperatorAbsenteeismFilterFields initialTableData={initialTableData} />;
      case "absenteeism_informed_reason_report_filter":
        return (
          <AbsenteeismInformedReasonFilterFields
            initialTableData={initialTableData}
          />
        );
      case "sales_contract_pos":
        return <SalesContractPOSFilterFields initialTableData={initialTableData} />;
      case "erp_usage_module":
        return <ERPUsageModuleFilterFields initialTableData={initialTableData} />;
      case "erp_usage_module_ui":
        return <ERPUsageModuleUiFilterFields initialTableData={initialTableData} />;
      case "erp_usage_issue":
        return <ERPUsageIssueFilterFields initialTableData={initialTableData} />;
      case "ob_filter":
        return <OBFilterFields initialTableData={initialTableData} />;
      case "he_ot_expense_data":
        return <HROTExpenseDataFilter initialTableData={initialTableData} />;
      case "digitalization-operator-efficiency":
        return <DigitalizationOperatorEfficiencyFilter initialTableData={initialTableData} />;
      case "audit_report":
        return <AuditReportFilter />;
      case "qc_validation_report":
        return <QcValidationReportFilter />;
      case "initial_sam_entry":
        return <InitialSAMEntryFilter initialTableData={initialTableData} />;

      case "remedy_map_filter":
        return <RemedyMapFilter initialTableData={initialTableData} />;
      case "remedy_logs_filter":
        return <RemedyMapFilter initialTableData={initialTableData} />;
      case "stock-lot-configs":
        return <StockLotConfigsFields initialTableData={initialTableData} />;

      case "lien_cost":
        return <LienCostFilterFields initialTableData={initialTableData} />;

      case "eb_collection_charge":
        return <EbCollectionChargeFilterFields initialTableData={initialTableData} />;

      case "transportation_cost":
        return <TransportationCostFilterFields initialTableData={initialTableData} />;

      case "export_doc_fee":
        return <ExportDocumentationFeeFilterFields initialTableData={initialTableData} />;

      case "b2b_lc_opening_cost":
        return <B2BLcOpeningCostFilterFields initialTableData={initialTableData} />;

      case "b2b_lc_acceptance_commission":
        return <B2BLCAcceptanceCommissionFilterFields initialTableData={initialTableData} />;

      case "b2b_lc_amendment_opening_cost":
        return <B2BLcAmendmentOpeningCostFilterFields initialTableData={initialTableData} />;

      case "amendment_lien_cost":
        return <AmendmentLienCostFilterFields initialTableData={initialTableData} />;

      case "BGMEA_UD_Amendment":
        return <BgmeaUdAmendmentFilterFields initialTableData={initialTableData} />;

      case "bgmea_ud_export_permission_cost":
        return <BgmeaUdExportPermissionCostFilterFields initialTableData={initialTableData} />;
      case "certificate_of_origin_fee":
        return (
          <CertificateOfOriginFeeFilterFields rtDocumentationFeeFilterFields initialTableData={initialTableData} />
        );
      case "marina_cover_note_bill":
        return <MarinaCoverNoteFilter initialTableData={initialTableData} />;
      case "hourly_packing_confirmation":
        return <HourlyPackingConfirmationFilterFields initialTableData={initialTableData} />;
      case "daily_packing_assignment":
        return <DailyPackingAssignmentFilterFields initialTableData={initialTableData} />;
      case "store_requisition":
        return <StoreRequisitionFilterFields initialTableData={initialTableData} />;

      default:
        return <></>;
    }
  };

  return (
    <Form
      form={form}
      name="advanced_search"
      className="ant-advanced-search-form"
      onFinish={(values) => onFinish(values, initialTableData, filterName)}
      layout="vertical"
    >
      <Row gutter={6}>
        <RenderFilterFields
          initialTableData={initialTableData}
          filterName={filterName}
          filterClearTrigger={filterClearTrigger}
        />
        {DATE_PRESET_FIELDS[filterName]?.map((pair) => (
          <Col span={24} key={`${pair.startName}-${pair.endName ?? "single"}`}>
            {pair.label && (
              <span style={{ marginRight: 8, fontWeight: 500 }}>{pair.label}:</span>
            )}
            <DateRangePresets
              form={form}
              startName={pair.startName}
              endName={pair.endName}
              onApply={isPreview && pair.apply !== "submit" ? runPreview : undefined}
            />
          </Col>
        ))}
        <Col span={customButton || filterName === "import_detail" || isPreview ? 8 : 4}>
          <Form.Item label=" " style={{ whiteSpace: "nowrap" }}>
            {customButton}
            <Button type="primary" htmlType="submit" size="small">
              {searchButtonText ? searchButtonText : "Search"}
            </Button>
            {isPreview && (
              <Button
                style={{
                  margin: "0 8px",
                }}
                size="small"
                onClick={runPreview}
              >
                {preview ? preview : "Preview"}
              </Button>
            )}
            {filterName === "import_detail" && (
              <Button
                style={{
                  margin: "0 8px",
                }}
                size="small"
                onClick={() => {
                  form.submit();
                  importDownload(form.getFieldsValue());
                }}
                disabled={disabledButton}
              >
                Download
              </Button>
            )}
            <Button
              type="primary"
              style={{
                margin: "0 8px",
              }}
              onClick={() => {
                form.resetFields();
                localStorage.removeItem(`${filterName}_filter_value`);
                if (window.location.search) {
                  window.history.pushState({}, '', window.location.pathname);
                }
                if (
                  [
                    "digitalization-garments-tracking",
                    "finishing-hourly-iron",
                    "finishing-hourly-fold",
                    "finishing-hourly-poly",
                    "mismatch-report-filter",
                    "digitalization_daily_finishing_line_plan",
                    "digitalization_daily_line_plan",
                  ].includes(filterName)
                ) {
                  setFilterClearTrigger((prev) => prev + 1);
                }
                onFinish(null, null, filterName);
              }}
              size="small"
            >
              Clear
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
});

const SearchForm = (props) => {
  const {
    tableData,
    filterName,
    fetchTableData,
    filterAPI,
    searchButtonText,
    customButton,
    importDownload,
    disabledButton,
    isPreview = false,
    previewFunction = () => { },
    setTableData,
    setSupplierType,
    filterValues,
    setFilterValues,
    preview = "Preview",
  } = props;
  const [initialTableData, setInitialTableData] = useState(null);

  useEffect(() => {
    // Only set initial data for the first time load
    if (tableData) {
      setInitialTableData(tableData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <AdvancedSearchForm
        tableData={tableData}
        initialTableData={initialTableData}
        filterName={filterName}
        fetchTableData={fetchTableData}
        filterAPI={filterAPI}
        searchButtonText={searchButtonText}
        customButton={customButton}
        importDownload={importDownload}
        disabledButton={disabledButton}
        isPreview={isPreview}
        previewFunction={previewFunction}
        setTableData={setTableData}
        setSupplierType={setSupplierType}
        filterValues={filterValues}
        setFilterValues={setFilterValues}
        preview={preview}
      />
    </div>
  );
};

export default memo(SearchForm);
